const CLARITY_PROJECT_ID = 'xxug3wkejg'

declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] }
  }
}

/**
 * Injects the official Microsoft Clarity tag once, globally, for every route.
 * Loaded asynchronously and after first paint so it never competes with the
 * LCP resource. Independent from the Meta Pixel — neither one touches the other.
 */
export function initClarity(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.clarity) return

  /* eslint-disable */
  ;(function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
    c[a] =
      c[a] ||
      function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }
    t = l.createElement(r)
    t.async = 1
    t.src = 'https://www.clarity.ms/tag/' + i
    y = l.getElementsByTagName(r)[0]
    // The tag boots after first paint, when the document may no longer have
    // any <script> node to anchor to — fall back to <head>/<body>.
    if (y && y.parentNode) {
      y.parentNode.insertBefore(t, y)
    } else {
      ;(l.head || l.body || l.documentElement).appendChild(t)
    }
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID)
  /* eslint-enable */
}
